import IgsosaNavbar from "../features/igsosa/components/Navbar";
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import styles from "../styles/igsosaApp.module.css";

import IgsosaHome from "../features/igsosa/pages/HomePage";
import AdminAuthIgsosa from "../features/igsosa/admin/AdminAuth";
import Projects from "../features/igsosa/pages/ProjectsPage";
import Gallery from "../features/igsosa/pages/GalleryPage";
import NotFound from "../features/igsosa/pages/NotFoundPage";

export default function IgsosaApp() {
  useEffect(() => {
    document.documentElement.classList.add("igsosa-scroll");
    document.body.classList.add("igsosa-scroll");

    return () => {
      document.documentElement.classList.remove("igsosa-scroll");
      document.body.classList.remove("igsosa-scroll");
    };
  }, []);

  return (
    <div className={styles.appshell}>
      <IgsosaNavbar />
      <Routes>
        <Route path="/" element={<IgsosaHome />} />
        <Route path="/admin" element={<AdminAuthIgsosa />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />

                  <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
